export default "__VITE_ASSET__BPQgbUnp__"